import {
  DlgDataAssetCar,
  DlgUserProfile,
  DlgDataQuote,
  DlgDataPolicyInfo
} from 'dlg-dolphin/dist/lib/interfaces/dlg-data';

import { DateTimeHelpers } from '@global/infrastructure/helpers/date-time-helpers';

export interface MapperStrategy {
  mapFeature(data: any): any;
}

export class AnalyticsMapper {
  constructor(private mapperStrategy: MapperStrategy) {
  }

  mapFeature(data: any): any {
    return this.mapperStrategy.mapFeature(data);
  }
}

export class MapperFactory {
  static create(featureName: string): AnalyticsMapper {
// tslint:disable-next-line: no-use-before-declare
    return new FeatureToAnalyticsMap()[featureName];
  }
}

export class PolicyMapper implements MapperStrategy {
  mapFeature(data: any): DlgDataPolicyInfo {
    return data;
  }
}

export class QuoteMapper implements MapperStrategy {
  mapFeature(data: any): DlgDataQuote {
    return data;
  }
}

export class CarMapper implements MapperStrategy {

  private static getNumberOfModifications(data: any): number {
    return data && data.length ? data.length : 0;
  }

  mapFeature(data: any): DlgDataAssetCar {
    return {
      make: data.make ? data.make : '',
      model: data.model ? data.model : '',
      year: data.year ? data.year : '',
      modified: data.vehicleModified ? data.vehicleModified : '',
      modifications: data.vehicleModifications
        ? CarMapper.getNumberOfModifications(data.vehicleModifications)
        : undefined,
      purchased: data.vehiclePurchased ? data.vehiclePurchased : '',
      purchased_date: data.vehiclePurchased
        ? data.vehiclePurchased === 'Yes'
          ? DateTimeHelpers.toFormat(data.vehiclePurchasedDate)
          : ''
        : '',
      value: data.estimatedValue ? data.estimatedValue : undefined,
      est_mileage: data.mileage ? data.mileage : undefined,
      registered_keeper: data.registeredKeeper
        ? data.registeredKeeper.value
          ? data.registeredKeeper.value
          : ''
        : '',
      home_overnight: '',
      use: ''
    };
  }
}

export class ProfileMapper implements MapperStrategy {

  private static getDriverAge(dateOfBirth: any): number {
    const today = new Date();
    const todayArray = [
      today.getDate().toString(),
      today.getMonth().toString() + 1,
      today.getFullYear().toString()
    ];
    return DateTimeHelpers.getDifferenceInYears(dateOfBirth, todayArray);
  }

  mapFeature(data: any): DlgUserProfile {
    let driverDetails;
    const dataDriver = data?.driverDetails ?? {};
    const DoB =
      dataDriver?.dateOfBirth?.length > 0
        ? new Date(
            +dataDriver.dateOfBirth[2],
            +dataDriver.dateOfBirth[1] - 1,
            +dataDriver.dateOfBirth[0]
          ).toString()
        : undefined;
    const age = dataDriver?.dateOfBirth
      ? ProfileMapper.getDriverAge(dataDriver.dateOfBirth)
      : undefined;

    if (data?.driverDetails) {
      driverDetails = {
        title: data.driverDetails.title ? data.driverDetails.title : '',
        DoB,
        age,
        employment_status: dataDriver?.employmentStatus?.value ?? '',
        gender: dataDriver?.gender ?? '',
        industry: dataDriver?.industry?.value ?? '',
        marital_status: dataDriver?.maritalStatus.value ?? '',
        occupation: dataDriver?.occupation?.value ?? '',
      };
    }

    const dataClaims = data?.claimsAndConvictions ?? {};

    const user = {
      ...driverDetails,
      convictions: dataClaims?.convictions?.length ?? 0,
      claims: dataClaims?.claims?.length ?? 0,
      email: data?.emailAddress ?? '',
      postcode: data?.postcode ?? '',
      postcode_first: (data?.postcode ?? '').split(' ')[0],
      children: data?.hasChildren?.displayAnswer ?? undefined,
      license_type: data?.licenseType?.value ?? '',
      uk_resident: data?.livedSinceBirth ?? '',
      uk_resident_since: (data?.livedSinceWhen ?? [])
        .join(' ')
        .toString()
        .replace(/,/g, '/'),
      years_license_held: data?.licenseHeldForYears?.value ?? undefined,
      policy: data?.policy,
      user_type: data?.userType,
    };

    Object.keys(user).forEach((key) => {
      if (!user[key]) {
        delete user[key];
      }
    });

    return user;
  }
}

export class FeatureToAnalyticsMap {
  'yourCarPerm' = new AnalyticsMapper(new CarMapper());
  'yourCarTemp' = new AnalyticsMapper(new CarMapper());
  'yourDetails' = new AnalyticsMapper(new ProfileMapper());
  'policy' = new AnalyticsMapper(new PolicyMapper());
  'quote' = new AnalyticsMapper(new QuoteMapper());
}
